import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SynechronGithubPicker } from './components/SynechronGithubPicker';
import { SynechronGithubPickerSchema } from './schema';
import { SynechronGithubPickerValidation } from './validation';

export const SynechronGithubPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SynechronGithubRepoPicker',
    component: SynechronGithubPicker,
    validation: SynechronGithubPickerValidation,
    schema: SynechronGithubPickerSchema,
  }),
);
